import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { useAppSelector } from "../../../redux";
import { EmojiProps } from "../../Emoji";
import { Slider } from "../Slider";
import { FlexColumn } from "../Styles";
import { VotedFeedBack } from "./VotedFeedBack";
import { PostsProps } from "../../../redux/slices/posts/Posts";

type props = {
  rating: PostsProps.RatingInteraction;
  isWithinRepostModal: boolean;
  onRatingSubmit: (ratingValue: number) => void;
};

export const RateContent = ({
  rating,
  isWithinRepostModal,
  onRatingSubmit,
}: props) => {
  const { typography } = useTheme();
  const { emojis } = useAppSelector((state) => state.me);
  const votedUsersCount = rating?.users_profile_pictures?.length;
  const isVoted = !!rating?.rating_interaction_user_voted;
  const leftEmoji = (emojis[rating?.left_emoji_id]?.name ||
    "ThumbsDown") as EmojiProps.EmojiType;
  const rightEmoji = (emojis[rating?.right_emoji_id]?.name ||
    "ThumbsUp") as EmojiProps.EmojiType;

  const onDragEnd = (ratingValue: number) => {
    if (!rating) return;
    onRatingSubmit(ratingValue);
  };

  if (!rating || !rating.id) return null;

  const aggregatePercent = rating.user_median_votes?.average_score;

  return (
    <QuestionContainer $gapInPx={8}>
      <Components.Text
        text={rating?.question}
        style={{ tokenStyle: typography.Body.L }}
        fontWeight="font-weight-semibold"
        lineHeight="line-height-200"
      />
      {isWithinRepostModal ? (
        <RateContainer>
          <Slider emojiValue={[leftEmoji, rightEmoji]} />
        </RateContainer>
      ) : (
        <RateContainer $gapInPx={8}>
          {isVoted && <VotedFeedBack votedUsersCount={votedUsersCount} />}
          <Slider
            emojiValue={[leftEmoji, rightEmoji]}
            isInteractive={!isVoted}
            isVoted={isVoted}
            onDragEnd={onDragEnd}
            aggregatePercent={aggregatePercent}
          />
        </RateContainer>
      )}
    </QuestionContainer>
  );
};

const QuestionContainer = styled(FlexColumn)(
  ({ theme }) => `
  border-radius: ${theme.radius["radius-xs"].value}rem;
  border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-neutral"].value};
  padding: ${theme.spacing["spacing-2"].value}rem;
  background: ${theme.Color.elevation.surface["surface-primary"].value};
`
);
const RateContainer = styled(FlexColumn)(
  ({ theme }) => `
  border-radius: ${theme.radius["radius-xs"].value}rem;
  border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-neutral"].value};
  padding-top: ${theme.spacing["spacing-6"].value}rem;
  padding-right: ${theme.spacing["spacing-2"].value}rem;
  padding-bottom: ${theme.spacing["spacing-6"].value}rem;
  padding-left: ${theme.spacing["spacing-2"].value}rem;
  
  `
);
